import { createLazyComponent } from '../shared/createLazyComponent';

// The assistant Shell (window frame) as its own lazy chunk — loaded once the drawer
// opens. rethrowOnError surfaces a failed import to the parent ErrorBoundary instead
// of leaving an unhandled rejection (see createLazyComponent).
export const LazyAssistantShell = createLazyComponent(
  () => import('./AssistantShell'),
  'AssistantShell',
  { label: 'Assistant Shell', rethrowOnError: true },
);
